import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import scroll from '@mailobj-browser/front/js/events/types/scroll.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../styles.js'
// @todo remettre l'import et supprimer offsetNotABottom quand $dev_chat_expand_zone sera supprimé
// import {offsetNotAtBottom} from "../dev_load.js";
const offsetNotAtBottom = 300

const onScroll = object(listener, {
  type: scroll,
  passive,
  task: (
    chatMessagesElt
  ) => {
    const scrollButton = one(`.${elements.scroll_to_bottom_button}`, chatMessagesElt.closest(`.${elements.chat}`))
    const { scrollHeight, scrollTop, offsetHeight } = chatMessagesElt

    if ((scrollHeight - (scrollTop + offsetHeight)) >= offsetNotAtBottom) {
      scrollButton.classList.remove(utilities.modifiers.display.none)
    } else {
      scrollButton.classList.add(utilities.modifiers.display.none)
    }
  }
})

export default container => {
  onScroll.listen(container)
}